// Copyright: IQGeo Limited 2010-2019
import L from 'leaflet';
import myw from 'myWorld-base';
import 'myWorld/base/util';

myw.MousePositionPlugin = myw.Plugin.extend({
    messageGroup: 'MousePositionControl',

    options: {
        enabled: true
    },

    // Actions to be used by map context menu
    actions: {
        toggle: {
            //unavailable on mobile devices
            //ENH: detect devices with mouses
            available: !myw.isTouchDevice,
            action: 'toggle',
            checked: 'control'
        }
    },

    /**
     * Creates the leaflet control and adds it to the application's map.
     * Options are passed on to the Leaflet control
     * @class   Plugin that adds a control to the map which displays the lat/long of the mouse position
     * @param  {Application}                owner       The application
     * @param  {mousePositionControlOptions}    options
     * @constructs
     * @extends {Plugin}
     */
    initialize(owner, options) {
        myw.Plugin.prototype.initialize.call(this, owner, options);

        if (this.options.enabled) this.enable();
    },

    enable() {
        this.control = new myw.MousePositionControl(this.options);
        this.app.map.addControl(this.control);
    },

    toggle() {
        if (this.control) {
            this.app.map.removeControl(this.control);
            this.control = null;
        } else {
            this.enable();
        }
    },

    /**
     * Returns object with current state details <br/>
     * @return {object}
     * @param {boolean} state.minimized Whether the minimap is minimized or not
     */
    getState() {
        return {
            enabled: !!this.control
        };
    }
});

/*
 * Map control plugin to display the current lat/lng
 */
myw.MousePositionControl = L.Control.extend({
    options: {
        position: 'topleft',
        decimalPlaces: 4
    },

    onAdd(map) {
        this._container = L.DomUtil.create('div', 'leaflet-bar-part');
        // event handler to up date the control
        map.on(
            'mousemove',
            function(e) {
                this._updateLatLngViewBox(e);
            },
            this
        );

        return this._container;
    },

    onRemove(map) {
        map.off('mousemove', this._updateLatLngViewBox);
    },

    /*
     * After the map is zoomed in or out update the control with current zoom level
     * @private
     */
    _updateLatLngViewBox(e) {
        const str = myw.Util.formatLatLng(e.latlng, this.options.decimalPlaces);
        //Add the leaflet-bar class and anchor element when the first mouse move is registered
        //So it doesn't get added to touch devices
        if (!this._container.childNodes.length) {
            this._container.className = `${this._container.className} leaflet-bar`;
            L.DomUtil.create('a', 'leaflet-control-mouseposition', this._container);
        }
        this._container.childNodes[0].innerHTML = str;
    }
});

export default myw.MousePositionPlugin;
